module.exports = __webpack_public_path__ + "assets/img/course_worksheet_head1.785837fe.png";